export default __webpack_public_path__ + "static/media/126.0dcb7e2f.jpg";